/**
 * Small dev-only logger. In production builds (`NODE_ENV === 'production'`)
 * these are no-ops so we don't leak internal error prefixes to end users.
 * In dev they behave identically to `console.warn`.
 *
 * Use in catch blocks:
 *   } catch (e) {
 *     devWarn("[PortalX] load failed:", e);
 *   }
 */
const _isDev = process.env.NODE_ENV !== "production";

export const devWarn = _isDev
  ? console.warn.bind(console)
  : () => {};

export const devError = _isDev
  ? console.error.bind(console)
  : () => {};
